import axios from "axios";
import {GET_USER_STATISTICS_URL, GET_PROPERTY_STATISTICS_URL, DEACTIVATE_PROPERTY_URL, DELETE_PROPERTY_URL} from "../api";
import errorHandler from "../utils/errorHandler";

export const getUserRegistrats = () => {
    return axios.get(GET_USER_STATISTICS_URL).then((response) => {
        return response.data;
    }).catch((error) => {
        errorHandler(error, "top-center");
    });
};

export const getPropertyStatistics = () => {
    return axios.get(GET_PROPERTY_STATISTICS_URL).then((response) => {
        return response.data;
    }).catch((error) => {
        errorHandler(error, "top-center");
    });
};

export const deactivateProperty = (id) => {
    return axios.post(DEACTIVATE_PROPERTY_URL, {id: id}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-center");
        return {
            error: true
        }
    });
};

export const deleteProperty = (id) => {
    return axios.post(DELETE_PROPERTY_URL, {id: id}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-center");
        return {
            error: true
        }
    });
};
